<template>
  <ul
    v-if="items && items.length"
    class="field__errorList"
  >
    <li
      v-for="(item, index) in items"
      :key="index"
      class="field__error"
    >
      {{ item }}
    </li>
  </ul>
</template>

<script>

export default {
  name: 'InputfieldErrors',
  props: {
    items: {
      type: Array,
      required: false,
      default () {
        return []
      },
    },
  },
}

</script>

<style lang="scss" scoped>

</style>
